import { render, staticRenderFns } from "./ModalFullscreenBase.vue?vue&type=template&id=1211d544&scoped=true"
import script from "./ModalFullscreenBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFullscreenBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211d544",
  null
  
)

export default component.exports